var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","title":_vm.currentLabel},on:{"click":_vm.cycleTheme}},[(_vm.currentTheme === 'light')?_c('v-icon',[_vm._v("mdi-white-balance-sunny")]):(_vm.currentTheme === 'dark')?_c('v-icon',[_vm._v("mdi-weather-night")]):_c('v-icon',[_vm._v("mdi-monitor")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }